import { useAppSelector } from 'hooks/reduxHooks'
import { isLEHotelItem } from 'lib/checkout/checkoutUtils'

/**
 * Returns whether any cart item for the given offer was added with bypassRegionFilter.
 * Used as a transient fallback in post-purchase summaries before svc-order persists
 * bypass_region on the order item.
 */
function useCartBypassRegionFilter(offerId: string): boolean {
  return useAppSelector(state =>
    state.checkout.cart.items.some(item => isLEHotelItem(item) && item.offerId === offerId && !!item.bypassRegionFilter),
  )
}

export default useCartBypassRegionFilter
